module.exports = __webpack_public_path__ + "img/add-candidate.8efdf0f9.svg";